import { Coding } from "@medplum/fhirtypes";

import { LOINCCodes } from "@/fhir/enums/loinc";
import { QuiltedHealthCodes, QuiltedHealthCodeSystems } from "@/fhir/enums/quilted-health";
import { Systems } from "@/fhir/enums/systems";

import { EDDDisplay } from "../types";

export const EDD_CODING: Coding = {
  system: Systems.LOINC,
  code: LOINCCodes.EDDWrapper,
  display: "Estimated Delivery Date",
} as const;

export const EDD_CODING_QUERY = `${EDD_CODING.system}|${EDD_CODING.code}`;

export const EDD_CODING_LMP: Coding = {
  system: Systems.LOINC,
  code: LOINCCodes.DeliveryDateEstimatedFromLMP,
  display: "Estimated Delivery Date from Last Menstrual Period",
} as const;

export const EDD_CODING_ULTRASOUND: Coding = {
  system: Systems.LOINC,
  code: LOINCCodes.DeliveryDateEstimatedFromUS,
  display: "Estimated Delivery Date from Ultrasound",
} as const;

export const EDD_CODING_CUSTOM: Coding = {
  system: Systems.LOINC,
  code: LOINCCodes.DeliveryDateEstimated,
  display: "Estimated Delivery Date from Custom",
} as const;

export const EDD_DISPLAY_CODING: Coding = {
  system: Systems.QH,
  code: QuiltedHealthCodes.EDDDisplay,
  display: "EDD to Display",
} as const;

export const EDD_DISPLAY_CODING_QUERY = `${Systems.QH}|${QuiltedHealthCodes.EDDDisplay}`;

export const EDD_DISPLAY_LMP_CODING: Coding = {
  system: QuiltedHealthCodeSystems.EDDDisplay,
  code: EDDDisplay.LMP,
  display: "LMP EDD",
} as const;

export const EDD_DISPLAY_ULTRASOUND_CODING: Coding = {
  system: QuiltedHealthCodeSystems.EDDDisplay,
  code: EDDDisplay.Ultrasound,
  display: "Ultrasound EDD",
} as const;

export const EDD_DISPLAY_CUSTOM_CODING: Coding = {
  system: QuiltedHealthCodeSystems.EDDDisplay,
  code: EDDDisplay.Custom,
  display: "Custom EDD",
} as const;

export const ULTRASOUND_DATE_CODING: Coding = {
  system: Systems.LOINC,
  code: LOINCCodes.UltrasoundDate,
  display: "Ultrasound Date",
} as const;

export const ULTRASOUND_DATE_CODING_QUERY = `${Systems.LOINC}|${LOINCCodes.UltrasoundDate}`;

export const GA_COMPOSITE_FROM_ULTRASOUND_CODING: Coding = {
  system: Systems.LOINC,
  code: LOINCCodes.GACompositeFromUS,
  display: "GA Composite from Ultrasound",
} as const;

export const GA_COMPOSITE_FROM_ULTRASOUND_CODING_QUERY = `${Systems.LOINC}|${LOINCCodes.GACompositeFromUS}`;
